import { omniaResolve } from "@omnia/shared/promises"
import { getHoldingFilter, IHolding } from "../../holding"
import { IOmniaSession } from "../../types"
import { defineDirective } from "../../utils/angular"

/** @internal */
export class ContextCtrl {


    static create(): ng.IDirective {

        return defineDirective(ContextCtrl, "shared/main/context/context.html", {
            holding: "=",
            year: "=",
            selectYear: "="
        })

    }

    selectYear: boolean

    singleHolding = false

    query = ""

    private _cache: Map<string, IHolding[]> = new Map()

    private _holding: IHolding
    public holdings: IHolding[]
    public dynamic = false

    public year: number
    public years: number[]

    static $inject = ["$scope", "OmniaSession"]

    constructor(private $scope: ng.IScope, private session: IOmniaSession) {
        $scope.$on("update-holdings", () => this.setup())
    }

    $onInit() {
        this.setup()
    }

    private setup() {
        this.dynamic = !this.session.hasFixedHoldings()
        this.holdings = this.session.getHoldings() || []
        this.singleHolding = this.holdings.length == 1
        this.holding = this.holding || (this.singleHolding ? this.holdings[0] : undefined)
    }

    get holding() {
        return this._holding
    }

    set holding(value: IHolding) {
        this._holding = value
        this.query = value ? value.TradingName : this.query
        this.years = value
            ? value.CropYears.map(c => c.YearId).sort((a, b) => b - a)
            : []
    }

    selectHolding(holding: IHolding) {
        this.holding = holding
    }

    filterHolding(text: string): ((item: IHolding) => boolean) {
        return getHoldingFilter(text)
    }

    queryHoldings(query: string) {

        const { session, _cache } = this

        const limit = (a: IHolding[]) => (a || []).slice(0, 15)

        if ((query = query || "").length < 2) {
            return omniaResolve([])
        }

        const cached = _cache.get(query)
        if (_cache.get(query)) {
            return omniaResolve(limit(cached))
        }

        return session.queryHoldings(query).then(r => {
            r = r || []
            _cache.set(query, r)
            return limit(r)
        })

    }

}


